import { Injectable } from '@angular/core';
import { Observable, of, switchMap, tap } from 'rxjs';
import { encrypt } from '../helpers/crypto-js';
import { AuthService } from './auth.service';
import { HttpClient } from '@angular/common/http';
import { GlobalVariable } from '../helpers/settings';
import { SwUpdate } from '@angular/service-worker';

@Injectable({
	providedIn: 'root'
})
export class RefreshVerificationService {
	readonly BASE_URL = `${GlobalVariable.server.host}/auth`;
	constructor(private authService: AuthService, private httpClient: HttpClient, private swUpdate: SwUpdate) {}
	buidResult<T>(res$: Observable<any>): Observable<T> {
		return res$.pipe(
			tap(res => {
				const auth = localStorage.getItem('auth');
				let authObject = JSON.parse(auth);
				if (authObject && res.authToken) {
					authObject.authToken = res.authToken;
					localStorage.setItem('auth', JSON.stringify(authObject));
				}
			}),
			switchMap(res => {
				if (res.refresh) {
					this.updateLocalUser(true);
				} else {
					if (this.swUpdate.isEnabled) {
						this.swUpdate.checkForUpdate();
						console.log('Manually checking for PWA update after successful write operation.');
					}
					return of(res.result);
				}
			})
		);
	}

	updateLocalUser(isReload = false) {
		const httpSubscription = this.httpClient.get<any>(`${this.BASE_URL}/get-auth-user`).subscribe(res => {
			const auth = localStorage.getItem('auth');
			const authObject = JSON.parse(auth);
			authObject.user = encrypt(JSON.stringify(res.result));
			localStorage.setItem('auth', JSON.stringify(authObject));
			httpSubscription.unsubscribe();
			if (isReload) window.location.reload();
		});
	}
}
